import { lazy } from 'react';

const LawyerReportRoutes = [
    {
        path: '/reports/lawyer_reports',
        component: lazy(() => import('../../pages/Reports/LawyerReports')),
        exact: true,
        meta: {
            action: 'read',
            resource: 'lawyer_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/complaints',
        component: lazy(() =>
            import('../../pages/Reports/LawyerReports/Complaints'),
        ),
        meta: {
            action: 'read',
            resource: 'lawyer_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/compliments',
        component: lazy(() =>
            import('../../pages/Reports/LawyerReports/Compliments'),
        ),
        meta: {
            action: 'read',
            resource: 'lawyer_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/top_lawyers',
        component: lazy(() =>
            import('../../pages/Reports/LawyerReports/TopLawyers'),
        ),
        meta: {
            action: 'read',
            resource: 'lawyer_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/hold_referral_to',
        component: lazy(() =>
            import('../../pages/Reports/LawyerReports/HoldReferralTo'),
        ),
        meta: {
            action: 'read',
            resource: 'lawyer_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/hold_list',
        component: lazy(() =>
            import('../../pages/Reports/LawyerReports/ReferralHoldList'),
        ),
        meta: {
            action: 'read',
            resource: 'lawyer_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/stop_list',
        component: lazy(() =>
            import('../../pages/Reports/LawyerReports/ReferralStopList'),
        ),
        meta: {
            action: 'read',
            resource: 'lawyer_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/archive_list',
        component: lazy(() =>
            import('../../pages/Reports/LawyerReports/ReferralArchiveList'),
        ),
        meta: {
            action: 'read',
            resource: 'lawyer_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/member_registration_comments',
        component: lazy(() =>
            import(
                '../../pages/Reports/LawyerReports/MemberRegistrationComments'
            ),
        ),
        meta: {
            action: 'read',
            resource: 'lawyer_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/member_list',
        component: lazy(() =>
            import('../../pages/Reports/LawyerReports/MemberList'),
        ),
        meta: {
            action: 'read',
            resource: 'lawyer_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/member_enrollment',
        component: lazy(() =>
            import('../../pages/Reports/LawyerReports/MemberEnrollmentReports'),
        ),
        meta: {
            action: 'read',
            resource: 'lawyer_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/member_registration_languages',
        component: lazy(() =>
            import(
                '../../pages/Reports/LawyerReports/MemberRegistrationByLanugage'
            ),
        ),
        meta: {
            action: 'read',
            resource: 'lawyer_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/member_registrations_by_practice_area',
        component: lazy(() =>
            import(
                '../../pages/Reports/LawyerReports/MemberRegistrationsByPracticeArea'
            ),
        ),
        meta: {
            action: 'read',
            resource: 'lawyer_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/member_registrations_by_legal_issue',
        component: lazy(() =>
            import(
                '../../pages/Reports/LawyerReports/MemberRegistrationsByLegalIssue'
            ),
        ),
        meta: {
            action: 'read',
            resource: 'lawyer_reports',
        },
    },

    /* APB */

    {
        path: '/reports/lawyer_reports/complaints_apb',
        component: lazy(() =>
            import('../../pages/Reports/LawyerReports/Complaints'),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/compliments_apb',
        component: lazy(() =>
            import('../../pages/Reports/LawyerReports/Compliments'),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/top_lawyers_apb',
        component: lazy(() =>
            import('../../pages/Reports/LawyerReports/TopLawyers'),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/hold_referral_to_apb',
        component: lazy(() =>
            import('../../pages/Reports/LawyerReports/HoldReferralTo'),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/hold_list_apb',
        component: lazy(() =>
            import('../../pages/Reports/LawyerReports/ReferralHoldList'),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/stop_list_apb',
        component: lazy(() =>
            import('../../pages/Reports/LawyerReports/ReferralStopList'),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/archive_list_apb',
        component: lazy(() =>
            import('../../pages/Reports/LawyerReports/ReferralArchiveList'),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/member_registration_comments_apb',
        component: lazy(() =>
            import(
                '../../pages/Reports/LawyerReports/MemberRegistrationComments'
            ),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/member_list_apb',
        component: lazy(() =>
            import('../../pages/Reports/LawyerReports/MemberList'),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/member_enrollment_apb',
        component: lazy(() =>
            import('../../pages/Reports/LawyerReports/MemberEnrollmentReports'),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/member_registration_languages_apb',
        component: lazy(() =>
            import(
                '../../pages/Reports/LawyerReports/MemberRegistrationByLanugage'
            ),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/member_registrations_by_practice_area_apb',
        component: lazy(() =>
            import(
                '../../pages/Reports/LawyerReports/MemberRegistrationsByPracticeArea'
            ),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
    {
        path: '/reports/lawyer_reports/member_registrations_by_legal_issue_apb',
        component: lazy(() =>
            import(
                '../../pages/Reports/LawyerReports/MemberRegistrationsByLegalIssue'
            ),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
];

export default LawyerReportRoutes;
